/* eslint-disable */
/*
	SSA Event Definition for Drushim**
	----------------------------------------------------------------------
	/!\ do not add properties without notifying the search team !!!
	we need to add them on our side in our model before you can send new
	events types or event properties.
	----------------------------------------------------------------------
*/
var ssaED = {}
/* base event. abstract  */
ssaED.Event = {}
ssaED.Event.eventId = function () {
	return ssaLogger.helper.guid()
}
ssaED.Event.previous = function () {
	return ssaLogger.getLastEvent()
}
ssaED.Event.url = function () {
	return window.location.href
}
ssaED.Event.referer = function () {
	return document.referrer
}
ssaED.Event.userAgent = 'const:' + navigator.userAgent
ssaED.Event.originId = 'js:ssa_originId' // use originId: 10000
ssaED.Event.sessionId = 'js:ssa_sessionId'
ssaED.Event.algorithm = 'js:ssa_abtest' //used when doing ab tests. useful to analyse results
ssaED.Event.cid = 'js:ssa_cid' //campaign id if you have such a thing.
ssaED.Event.userHashId = 'js:ssa_userHashId' // cookie based  user id (when not logged)
ssaED.Event.myStepStoneId = 'js:ssa_myStepStoneId' // user id for logged in users
ssaED.Event.ssaHash = 'js:ssa_ssaHash' // SSA hash computed as follows :
ssaED.Event.source = 'js:ssa_source' // only fill in when it is coming from smart agent, saved search, job per email, ijm etc
ssaED.Event.ABTestCookie = 'js:ABTestCookie'
ssaED.Event.CookieExperation = 'js:CookieExperation'
/* default event that we can log when we dont know what else to log */
ssaED.DefaultEvent = {}
ssaED.DefaultEvent._parent = 'Event' // defines this event inherit all the properties of "Event"

/* homepage */
ssaED.HomePage = {}
ssaED.HomePage._parent = 'Event' // defines this event inherit all the properties of "Event"


/* Job/Listing Events */
//abstract job events. (parents for other job events)
ssaED.CommonListingEvent = {}
ssaED.CommonListingEvent._parent = 'Event' // defines this event inherit all the properties of "Event". recommenderUUID and searchUUID will be added by ssaLogger.postEvent()
ssaED.CommonListingEvent.listingId = 'js:ssa_jobid'
ssaED.CommonListingEvent.positionOnResultList = 'js:ssa_positionOnResultList'
ssaED.CommonListingEvent.positionOnPage = 'js:ssa_positionOnPage'
ssaED.CommonListingEvent.jobagentId = 'js:ssa_jobAgentId'
//dividing listing to types
ssaED.CommonListingEvent.features = function (event) {
	features = []
	if (IsPreferred) {
		if (IsHot) {
			features = ['preferred', 'hot']
		} else {
			features = ['preferred']
		}
	} else {
		if (IsHot) {
			features = ['hot']
		}
	}
	return features
}


//when users views a job
ssaED.ListingView = {}
ssaED.ListingView._parent = 'CommonListingEvent'


//when user opens apply form or click apply link
//OAF stands for online application form. ie. apply form :)
ssaED.ListingOAFClicked = {}
ssaED.ListingOAFClicked._parent = 'CommonListingEvent' // defines this event inherit all the properties of "CommonListingEvent"

//when user submit apply form
ssaED.ListingOAFSent = {}
ssaED.ListingOAFSent._parent = 'CommonListingEvent' // defines this event inherit all the properties of "CommonListingEvent"

//bulk apply events
ssaED.ListingAddedToOAFBulk = {}
ssaED.ListingAddedToOAFBulk._parent = 'CommonListingEvent' // defines this event inherit all the properties of "CommonListingEvent"
//note it will inherit listing id form : ssaED.CommonListingEvent.listingId = 'js:ssa_jobid'

ssaED.ListingOAFClickedBulk = {}
ssaED.ListingOAFClickedBulk._parent = 'Event' // defines this event inherit all the properties of "CommonListingEvent"
ssaED.ListingOAFClickedBulk.listingIds = 'js:ssa_jobids' //must be an array of integers

ssaED.ListingOAFSentBulk = {}
ssaED.ListingOAFSentBulk._parent = 'Event' // defines this event inherit all the properties of "CommonListingEvent"
ssaED.ListingOAFSentBulk.listingIds = 'js:ssa_jobids' //must be an array of integers

//optional when user save job in his list of jobs
ssaED.ListingSave = {}
ssaED.ListingSave._parent = 'CommonListingEvent' // defines this event inherit all the properties of "CommonListingEvent"

//optional
ssaED.ListingIgnore = {}
ssaED.ListingIgnore._parent = 'CommonListingEvent' // defines this event inherit all the properties of "CommonListingEvent"

//optional
ssaED.ListingSendToFriend = {}
ssaED.ListingSendToFriend._parent = 'CommonListingEvent' // defines this event inherit all the properties of "CommonListingEvent"


/* Searches */
// paging thru search result pages.
ssaED.SearchPaging = {}
ssaED.SearchPaging._trigger = function () {
	var params = window.location.href.substring(window.location.href.indexOf('?'))
	return (
		window.location.pathname.match('/search?.*') &&
		params.match('^.*offset=.*$')
	)
}
ssaED.SearchPaging.searchUUID = function () {
	return ssaLogger.getSearchUUID()
}
ssaED.SearchPaging._parent = 'Event'
ssaED.SearchPaging.listingIds = 'js:ssa_listingids'
ssaED.SearchPaging.numberOfTotalResults = 'js:ssa_numberOfTotalResults' // total number of result matching the search criteria
ssaED.SearchPaging.offset = 'js:ssa_offset' // if on page 3 (page 10 results) : 30
ssaED.SearchPaging.pageNumber = 'js:ssa_pageNumber'
ssaED.SearchPaging.orderBy = 'js:ssa_sort' //string containing the sort order selected
ssaED.SearchPaging.resultsPerPage = 'js:ssa_resultsPerPage'
ssaED.SearchPaging.searchType = 'js:ssa_searchType'
//search paging
ssaED.SearchPaging.featuredListingIds = function (event) {
	featuredListings = {}
	featuredListings.preferred = PreferredIds
	featuredListings.hot = HotIds
	return featuredListings
}
ssaED.SearchPaging.filters = function (event) {
	return ssa_Filters
}

// refining a search
ssaED.SearchFaceting = {}
ssaED.SearchFaceting._parent = 'SearchPaging'
ssaED.SearchFaceting.whatSearch = 'js:ssa_what'
ssaED.SearchFaceting.whereSearch = 'js:ssa_where'
ssaED.SearchFaceting.whereRadius = 'js:ssa_where_radius'

// actual new search (resting all filters and sorting). typically when the user click the "search button".
ssaED.Search = {}
ssaED.Search._parent = 'SearchFaceting'
ssaED.Search.searchUUID = function (event) {
	return ssaLogger.getAndSetSearchUUID(event)
}


//Recommender events
ssaED.RecommenderListingsDisplayed = {}
ssaED.RecommenderListingsDisplayed._parent = 'Event'
ssaED.RecommenderListingsDisplayed.listingIds = 'js:ssa_listingids'
ssaED.RecommenderListingsDisplayed.featuredListingIds = function (event) {
	featuredListings = {}
	featuredListings.preferred = RecommendadJobsPreferredIds
	return featuredListings
}
ssaED.RecommenderListingsDisplayed.recommenderUUID = function (event) {
	return ssaLogger.getAndSetRecommenderUUID(event)
}



var ssaLogger

function setLogger(logger) {
	ssaLogger = logger
	return ssaLogger
}

module.exports = {
	ssaED,
	setLogger
}

/*** EXPORTS FROM exports-loader ***/
exports["ssaED"] = (ssaED);
exports["setLogger"] = (setLogger);